import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능/운영분석 화면 / 인터페이스 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params
   * objId, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   */
  getInterfaceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-interface-list.do`, params);
  },
  getCurrentInterfaceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-interface-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / PoE 인터페이스 전력 테이블 리스트를 가져옵니다.
   * @author {Hunui}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPoeInterfacePowerList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-poe-interface-power-list.do`, params);
  },
  getCurrentPoeInterfacePowerList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-poe-interface-power-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 연결 장비 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params
   * objId, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   */
  getConnectionDeviceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-interface-arp.do`, params);
  },
  getCurrentConnectionDeviceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-interface-arp.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 라우트 정보 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params
   * objId, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   */
  getRoutingInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-routing-list.do`, params);
  },
  getCurrentRoutingInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-routing-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / Tcp 정보 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params
   * objId, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   */
  getTcpInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-tcp-list.do`, params);
  },
  getCurrentTcpInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-tcp-list.do`, params);
  },

  /**
   * 성능/운영분석 화면 / Syslog 테이블 리스트를 가져온다.
   * @author {Yang}
   * objId, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   * @return {[json파일]}  [Tcp 정보 리스트]
   */
  getSysLogList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-syslog-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / config 변경 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {[object]} params objId, endDatetime
   * @return {[map<String,String>]}  [config 변경 리스트]
   */
  getChangedConfigInfo(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-changed-config-info.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 하드웨어 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {Integer} params objId
   * objId
   * @return {[List<Map>]]}  [[hardwareName : 상태, hardwarekind : 종류, hardwareName : 이름, hardwareSerialNum : 시리얼 번호]]
   */
  getHardwareStateList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-hardware-state-list.do`, params);
  },
  getCurrentHardwareStateList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-hardware-state-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / L4세션 설정 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {Integer} params objId
   * objId
   * @return {[List<L4Status>]]}
   */
  getL4Settings(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-l4-session-settings.do`, { objCompanyId: params });
  },
  /**
   * 성능/운영분석 화면 / L4세션 설정 테이블 리스트를 업데이트 한다.
   * @author {Yang}
   * @param  {List<L4Status>} params
   * objId
   * @return {[boolean]]} success
   */
  updateL4Settings(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/update-l4-session-settings.do`, params);
  },
  /**
   * 성능/운영분석 화면 / L4세션 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  getL4SessionList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-l4-session-list.do`, params);
  },
  getCurrentL4SessionList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-current-l4-session-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 프로세스 스냅샷을 가져온다.
   * @author {Yang}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  getProcessSnapshot(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-process-snapshot.do`, params);
  },
  /**
   * 성능/운영분석 화면 / 현재 프로세스 리스트를 가져온다.
   * @author {Yang}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  getProcessList(objId) {
    return axios.get(`${baseUrl}/performance/analysis/netdevice/get-process-list.do`, { params: { objId } });
  },
  /**
   * 성능/운영 > 분석 > L4 세션 상태 추가
   * @author {Song}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  insertLfourSessionStatusList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/insert-lfour-session-status-list.do`, params);
  },
  /**
   * 성능/운영 > 분석 > L4 세션 상태 제거
   * @author {Song}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  deleteLfourSessionStatusList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/delete-lfour-session-status-list.do`, params);
  },
  /**
   * 성능/운영 > 분석 > L4 세션 상태 중복검사
   * @author {Song}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  getDuplicateCheckLfourStatus(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-duplicate-check-lfour-status.do`, params);
  },
  /**
   * 성능/운영 > 분석 > L4 세션 - 테이블 확장 (물리서버) 조회
   * @author {Song}
   * @param  {nteger} params objId, startDatetime, endDatetime
   * objId
   */
  getLfourRealServerDataList(params) {
    return axios.post(`${baseUrl}/performance/analysis/netdevice/get-lfour-real-server-data-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/netdevice/netdevice-table-info.js